import {api} from './api';

export interface WaitlistItem {
    id: number;
    name: string;
    email: string;
    direction: string;
    status: string;
    remark: string | null;
    deleted: string;
    ipAddress: string | null;
    createdTime: string;
    updatedTime: string;
}

export interface PageResponse<T> {
    content: T[];
    totalElements: number;
    totalPages: number;
    number: number;
    size: number;
}

export const waitlistService = {
    getList: async (page: number = 0, size: number = 20): Promise<PageResponse<WaitlistItem>> => {
        const response = await api.get(`/api/v1/admin/waitlist?page=${page}&size=${size}`);
        return response.data.data;
    },

    getDetail: async (id: number): Promise<WaitlistItem> => {
        const response = await api.get(`/api/v1/admin/waitlist/${id}`);
        return response.data.data;
    },

    updateStatus: async (id: number, status: string, remark?: string): Promise<WaitlistItem> => {
        let url = `/api/v1/admin/waitlist/${id}/status?status=${status}`;
        if (remark) {
            url += `&remark=${encodeURIComponent(remark)}`;
        }
        const response = await api.put(url);
        return response.data.data;
    },

    delete: async (id: number): Promise<void> => {
        await api.delete(`/api/v1/admin/waitlist/${id}`);
    },

    submit: async (name: string, email: string, direction: string): Promise<WaitlistItem> => {
        const response = await api.post('/api/v1/public/waitlist', {name, email, direction});
        return response.data.data;
    },
};
